export const T_CORP_TICKET_URL = "https://t.corp.amazon.com";

export const METRICS_NAMESPACE = "GFT-A3S-UI";

export enum MCMInputToolLink {
    PROD_MCM_INPUT_TOOL_LINK = "https://paw-admin.corpprod.fpa.amazon.dev/?perspective=dashboard&id=28d82e2f-a68c-4926-9369-f603aed1d788",
    GAMMA_MCM_INPUT_TOOL_LINK = "https://paw.corpdev.fpa.amazon.dev/?perspective=dashboard&id=de9a9c6c-0596-4a2a-8a12-908feee56e92",
}

export enum SharedSimulationKeys {
    IS_SHARED = "is_shared",
    IS_SHARED_BY_ME = "is_shared_by_me",
}
